import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-receptionist-menu',
  templateUrl: './receptionist-menu.component.html',
  styleUrls: ['./receptionist-menu.component.css']
})
export class ReceptionistMenuComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
